import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export default function ProtectedRoute({ children, requiredRole = null }) {
  const { user, userData, loading } = useAuthStore()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Check role if required
  if (requiredRole) {
    if (requiredRole === 'operator' && !['operator', 'admin'].includes(userData?.role)) {
      return <Navigate to="/dashboard" replace />
    }
    
    if (requiredRole === 'admin' && userData?.role !== 'admin') {
      return <Navigate to="/dashboard" replace />
    }
  }

  return children
}
